import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";  // Optional, if you plan to use Firebase Auth
import { getFunctions } from "firebase/functions";
// import authProvider from "./providers/authProvider";


const firebaseConfig = {
    apiKey: "AIzaSyDQWmhmutl4Bo5N4VIF916xzcVETVC7D7U",
    authDomain: "seismic-relic-390308.firebaseapp.com",
    projectId: "seismic-relic-390308",
    storageBucket: "seismic-relic-390308.appspot.com",
    messagingSenderId: "936727868630",
    appId: "1:936727868630:web:1d1530d3d2e8a73938c577",
    measurementId: "G-8CQ2T4YF4Y",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const functions = getFunctions(app);
// const analytics = getAnalytics(app);

export { auth, app, functions };